import { render, staticRenderFns } from "./ParentsDocuments.vue?vue&type=template&id=590fc565&"
import script from "./ParentsDocuments.vue?vue&type=script&lang=js&"
export * from "./ParentsDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports